import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./style.css";
// import "../RelationShip/RelationShipChatScreen/style.css"
import RelationShipChat from "../RelationShip/RelationShipChatScreen/RelationShipChat";
import {
  getSurveyQuestions,
  submitSurveyAnswer,
} from "../../Services/newSurvey";
import { convertApiResponse } from "../../Utils/CommonFunctions/survey";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { getUserProfile } from "../../Services/MyProfile";
import { chatCreateRelationShip } from "../../Services/arisAI";
import AddRelationShipChatModal from "../RelationShip/AddRelationShipChatModal";
import { ONBOARDING_STEPS, SIGNUP_ROUTES } from "../../Utils/onboardingNavigation";

import "../RelationShip/style.css";
import { assignLicense, getLicenceList } from "../../Services/subscription";
function NewSurvey() {
  const {
    setHeaderContent,
    setHeaderContentRightSideContent,
    addProfileData,
    profileContent,
  } = useHeader();

  const navigate = useNavigate();
  useEffect(() => {
    // Ensure user has reached subscription step in onboarding before rendering chat
    const profile = JSON.parse(localStorage.getItem("profile") || "{}");
    const steps = profile?.onboarding_step;
    const hasSubscription = Array.isArray(steps)
      ? steps.includes(ONBOARDING_STEPS.SUBSCRIPTION)
      : steps === ONBOARDING_STEPS.SUBSCRIPTION;

    if (!hasSubscription) {
      navigate(SIGNUP_ROUTES[ONBOARDING_STEPS.SUBSCRIPTION]);
      return; // do not proceed to load chat yet
    }

    // Only treat as first render after a real page refresh (per tab)
    const ssKey = "new_survey_initialized";
    const alreadyInitialized = sessionStorage.getItem(ssKey);
    if (!alreadyInitialized) {
      sessionStorage.setItem(ssKey, "1");
      callNextQuest(true);
    } else {
      // On remounts without refresh, do not mark first render
      callNextQuest();
    }
    if (profile?.user_type === "primary") {
      fetchLicenceListData();
    }
  }, []);
  useLayoutEffect(() => {
    setHeaderContent(true);
    setHeaderContentRightSideContent(false);
  }, []);

  const [chatData, setchatData] = useState([]);
  const [lastQuestType, setlastQuestType] = useState(null);
  const [loadingDataFromAPI, setloadingDataFromAPI] = useState(false);
  const [lastQuestID, setlastQuestID] = useState("");
  const [lastQuestIDToSend, setlastQuestIDToSend] = useState("");

  const [addRelationShipFlag, setaddRelationShipFlag] = useState(false);
  const [chatDtatHistory, setchatDataHistory] = useState([]);
  const [showEditRelationship, setshowEditRelationship] = useState(false);
  const [collectedFormDataRelationship, setcollectedFormDataRelationship] =
    useState({});
  const [licenseDetails, setlicenseDetails] = useState([]);
  const [licenseSubscriptionId, setLicenseSubscriptionId] = useState(null);
  const [
    addRelationShipWithAvailableLicense,
    setaddRelationShipWithAvailableLicense,
  ] = useState(false);
  const [showLicensePop, setshowLicensePop] = useState(false);

  const addRelationShipFlagRef = useRef();

  const pushInData = async (data) => {
    console.log(data, addRelationShipFlag, "lkj");
    if (
      (chatData[chatData?.length - 1]?.content?.options &&
        chatData[chatData?.length - 1]?.content?.options?.filter(
          (_c) => _c?.label === "Other(Write your own below)"
        )?.length !== 0) ||
      false ||
      data === ""
    ) {
      return;
    } else if (addRelationShipFlag || addRelationShipFlagRef.current) {
      onAddNewContactWithChat(data, chatDtatHistory);
    } else {
      setchatData((prev) => [
        ...prev,
        {
          role: "user",
          content: data,
          isSurvey: true,
        },
      ]);

      await submitAnswer(lastQuestIDToSend, data);
    }
  };

  const onAddNewContactWithChat = (data, history = [], isFirst = false) => {
    console.log(data, "lkj111");

    if (data?.length === 0 || data === undefined || data === null) {
      setchatData((prev) => [...prev, { role: "system", content: "" }]);
    } else {
      setchatData((prev) => [
        ...prev,
        { role: "user", content: data },
        { role: "system", content: "" },
      ]);
    }
    let tmp = {
      name: profileContent?.first_name,
      tag: "onboarding",
      query: data,
      history: history,
    };
    chatCreateRelationShip(tmp)
      .then((res) => {
        if (res?.is_conversation_done) {
          setTimeout(() => {
            if (licenseDetails?.length === 0) setshowEditRelationship(true);
            else setshowLicensePop(true);
            setcollectedFormDataRelationship(res?.form);
          }, 800);

          // collectedRelationShipFormData.current = res?.form;
        } else {
          setlastQuestID(res?.query || "");
          setchatData((prevItems) => {
            if (prevItems.length === 0) return prevItems;
            const newItems = [...prevItems];
            newItems[newItems.length - 1] = {
              ...newItems[newItems.length - 1],
              content:
                res?.query?.length > 0
                  ? res?.query
                  : "Something went wrong- Aris",
            };
            return newItems;
          });
          setchatDataHistory((prev) => [
            ...prev,
            { role: "user", content: data },
            { role: "assistant", content: res?.query },
          ]);
        }
      })
      .catch((err) => {
        setchatData((prevItems) => {
          if (prevItems.length === 0) return prevItems;
          const newItems = [...prevItems];
          newItems[newItems.length - 1] = {
            ...newItems[newItems.length - 1],
            content: "Something went wrong- Aris",
          };
          return newItems;
        });
      });
  };

  const fetchLicenceListData = async () => {
    try {
      const response = await getLicenceList();
      // Handle new response format:
      // { status, status_code, message, payload: { subscription_id, unassigned_count, unassigned: [...] } }
      const data = response?.payload || response;
      setlicenseDetails(data?.unassigned || []);
      setLicenseSubscriptionId(data?.subscription_id || null);
    } catch (error) {
      console.warn("Failed to load unassigned licenses");
    }
  };

  const addConvertedToChat = (converted) => {
    if (!converted || converted.length === 0) return;

    setchatData((prevChatData) => {
      if (prevChatData.length === 0) return prevChatData;
      setlastQuestID(converted[0]?.content?.desc);

      const newItems = [...prevChatData];
      newItems[newItems.length - 1] = converted[0];
      return newItems;
    });

    const remainingItems = converted.slice(1);

    remainingItems.forEach((item, index) => {
      setTimeout(() => {
        setlastQuestID(item?.content?.desc);
        setchatData((prevChatData) => [...prevChatData, item]);

        if (item?.add_relation) {
          addRelationShipFlagRef.current = true;
          setaddRelationShipFlag(true);
          setTimeout(() => {
            onAddNewContactWithChat("", [], true);
          }, 1000);
        }
      }, (index + 1) * 800); // index+1 because 0th was already added
    });
  };

  const callNextQuest = (is_first_render = false) => {
    setchatData((prevChatData) => [
      ...prevChatData,
      {
        role: "system",
        content: "",
        message_type: "",
        isSurvey: true,
      },
    ]);
    getSurveyQuestions(is_first_render)
      .then((res) => {
        setlastQuestIDToSend(res[res?.length - 1]?.question_id);
        let converted = convertApiResponse(res);

        addConvertedToChat(converted);
        setloadingDataFromAPI(false);
        setlastQuestType(converted[converted?.length - 1]?.message_type);

        setlastQuestIDToSend(converted[converted?.length - 1]?.question_id);
      })
      .catch((err) => {
        setloadingDataFromAPI(false);
        setchatData((prevChatData) => {
          if (prevChatData.length === 0) return prevChatData;
          const newItems = [...prevChatData];
          newItems[newItems.length - 1].content = {
            desc:
              err?.message ||
              err?.response?.data?.message ||
              "Something Went wrong Please try after some time ...",
            options: [],
          };
          return [...newItems];
        });
      });
  };

  const submitAnswer = async (question_id, label) => {
    await submitSurveyAnswer(question_id, label)
      .then((res) => {
        callNextQuest();
      })
      .catch((err) => console.error(err));
  };

  const optionSelected = async (data) => {
    if (data?.type === "CTA") {
      if (data?.startAssessment) {
        const queryParams = new URLSearchParams();
        const categoryId = data?.nextCategoryId || "";
        queryParams.append("categoryId", categoryId);
        navigate(`/onboarding/instructions?${queryParams.toString()}`);
      } else if (!data?.startAssessment && data?.userStory) {
        const queryParams = new URLSearchParams();
        const fromOnBoarding = true;
        queryParams.append("fromOnBoarding", fromOnBoarding);
        navigate(
          `/onboarding/story/${data?.userStory}?fromOnBoarding=${fromOnBoarding}`
        );
      } else if (data?.load_chat) {
        getUserProfile().then((res) => {
          localStorage.setItem("profile", JSON.stringify(res));
          addProfileData(res);
          navigate("/dashboard");
          localStorage.setItem("showConfetti", true);
        });
      } else if (data?.add_relation) {
        addRelationShipFlagRef.current = true;
        setaddRelationShipFlag(true);
        setloadingDataFromAPI(true);
        onAddNewContactWithChat();
      } else {
        callNextQuest();
      }
    } else {
      if (data?.selectedChoice && data?.selectedChoice?.length !== 0) {
        let optedString = data?.selectedChoice?.join(", ");
        setchatData((prev) => [
          ...prev,
          {
            role: "user",
            content: data?.selectedChoice || data,
            type: data?.type,
            hearderQuest: data?.headerQuest || "",
          },
        ]);
        await submitAnswer(data?.question_id, optedString);
      } else {
        setchatData((prev) => [
          ...prev,
          {
            role: "user",
            content: data?.label || data,
            hearderQuest: data?.headerQuest || "",
          },
        ]);
        await submitAnswer(data?.question_id, data?.label);
      }
    }
  };

  const onAddRealtionClose = async () => {
    setshowEditRelationship(false);
    // await submitAnswer(lastQuestID, "");
    addRelationShipFlagRef.current = false;

    setaddRelationShipFlag(false);
    setchatDataHistory([]);
    callNextQuest();
  };

  const onAddedRelationShip = (data) => {
    setchatData((prevItems) => {
      if (prevItems.length === 0) return prevItems;
      const newItems = [...prevItems];
      newItems[newItems.length - 1] = {
        ...newItems[newItems.length - 1],
        content: "Relationship added succesfully",
      };
      return newItems;
    });
  };

  const addNewRelationship = () => { };

  const addLicenseToUser = () => {
    setaddRelationShipWithAvailableLicense(true);
    setshowLicensePop(false);
    setshowEditRelationship(true);
  };

  const cancelLicenseToUser = () => {
    setaddRelationShipWithAvailableLicense(false);
    setshowLicensePop(false);
    setshowEditRelationship(true);
  };

  return (
    <div className="new-survey-hero-container">
        {showEditRelationship && (
          <AddRelationShipChatModal
            title={"Add new Relationship"}
            onClose={onAddRealtionClose}
            contact={collectedFormDataRelationship}
            onAddClick={addNewRelationship}
            onAddedRelationShip={onAddedRelationShip}
            // showEmail={
            //   licenseDetails?.length > 0 && addRelationShipWithAvailableLicense
            // }
            isSurveyAdd={true}
            licenseDetails={licenseDetails}
            subscriptionId={licenseSubscriptionId}
            addRelationShipWithAvailableLicense={
              addRelationShipWithAvailableLicense
            }
            skipClose={true}
          />
        )}
        <div
          className={`relationship-parent-scroll-container`}
        >
          <div
            className={`relationship-container ${chatData.length === 0 && "relation-chat-cont-initial"
              }`}
          >
            <RelationShipChat
              onEnterData={pushInData}
              chatData={chatData}
              awaitingResponse={false}
              onOptionSelected={optionSelected}
              hideChatInput={
                lastQuestType === "cta" ||
                lastQuestType === "actionable" ||
                lastQuestType === "clickable"
              }
              isAiLoading={loadingDataFromAPI}
              lastQuestID={lastQuestID}
              restrictEnterManualData={
                (chatData[chatData?.length - 1]?.content?.options &&
                  chatData[chatData?.length - 1]?.content?.options?.filter(
                    (_c) => _c?.label === "Other(Write your own below)"
                  )?.length !== 0) ||
                false
              }
              isSurvey={true}
              isChatLoading={
                chatData && chatData[chatData?.length - 1]?.content === ""
              }
            />
          </div>
        </div>
      {showLicensePop && (
        <>
          <div className="join-aris-overlay license-overlay">
            <div
              className="join-aris-modal license-modal"
              style={{ paddingBottom: "2px", width: "60%", maxWidth: "500px" }}
            >
              <div className="join-aris-header" style={{ marginBottom: "0px" }}>
                <div>
                  <h2 className="join-aris-title">
                    {`Would you like to assign a membership to ${collectedFormDataRelationship?.first_name}?`}
                  </h2>
                </div>
                {/* <button
                // onClick={onCancelConfirmation}
                className="join-aris-close-btn"
              >
                <Close />
              </button> */}
              </div>
              <div style={{ marginBottom: "24px" }}></div>
              {/* <p className="join-aris-subtitle">{errorMsgToBeShownOnInvite}</p> */}

              {/* {errorMsg && (
            <p style={{ color: "red", textAlign: "center" }}>{errorMsg}</p>
          )} */}
              <div className="logout-modal-button-container">
                <div className="logout-cancel" onClick={addLicenseToUser}>
                  {"Yes"}
                </div>
                <div
                  className="logout-cancel logout-btn"
                  onClick={cancelLicenseToUser}
                >
                  No
                </div>
              </div>
            </div>
          </div>
        </>
      )
      }
    </div >
  );
}

export default NewSurvey;
